<template>
    <div class="bloco margem" v-if="sprint.tarefas">
        <table class="tabela">
            <tbody>
                <tr>
                    <th>
                        <strong>
                            Código
                        </strong>
                    </th>
                    <th>
                        <strong>
                            Descrição
                        </strong>
                    </th>
                    <th>
                        <strong>
                            H.P.
                        </strong>
                    </th>
                    <th>
                        <strong>
                            Responsável
                        </strong>
                    </th>
                    <th>
                        <strong>
                            Início Previsto
                        </strong>
                    </th>
                    <th>
                        <strong>
                            Fim Previsto
                        </strong>
                    </th>
                    <th style="padding: 0rem;">
                        <strong>
                            Status
                        </strong>
                    </th>
                    <th>
                    </th>
                </tr>
                <tr v-for="element in sprint.tarefas" :key="element.id" @mouseover="mostrarBotao(element.id, true)"
                    @mouseleave="mostrarBotao(element.id, false)">
                    <td>
                        <span style="width: 100%; white-space: nowrap;">{{
                            element.codigo }}</span>
                    </td>
                    <td class="clicavel" style="text-align: left;">
                        <div @click="abrirModalEditarBacklog(element)" :title="element.descricao"
                            style="display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis">
                            {{ element.descricao }}
                        </div>
                    </td>
                    <td class="clicavel">
                        <select v-model="element.HP" class="HP" @focusout="editarBacklog('HP', element.id, element.HP)"
                            style="opacity: 1;width: 2.5rem; height: 2.5rem;text-align: center; border-radius: 50%; padding: 0;">
                            <option hidden>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>5</option>
                            <option>8</option>
                            <option>13</option>
                            <option>21</option>
                            <option>34</option>
                            <option>55</option>
                            <option>89</option>
                            <option>144</option>
                            <option>233</option>
                        </select>
                    </td>
                    <td class="clicavel">
                        <select v-model="element.responsavel_id"
                            style="opacity: 1;background-color: transparent;min-width: max-content; border: none;"
                            @change="editarBacklog('responsavel_id', element.id, element.responsavel_id)">
                            <option hidden>Responsável</option>
                            <option v-for="item in gerente" :key="item.id" :value="item.id">
                                {{ nomeEsobrenome(item.nomeCompleto) }}
                            </option>
                        </select>
                    </td>
                    <td class="clicavel">
                        <input
                            style="opacity: 1;cursor: pointer; width: 7rem; text-align: left; padding-inline: 0rem; border: none; background-color: transparent;"
                            type="date"
                            @change="editarBacklog('dtInicio', element.id, (element.dtInicio + ' ' + `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`))"
                            v-model="element.dtInicio">
                    </td>
                    <td class="clicavel">
                        <input
                            style="opacity: 1;cursor: pointer; width: 7rem; text-align: left; padding: 0rem; border: none; background-color: transparent;"
                            type="date" :min="element.dtInicio"
                            @change="editarBacklog('dtFim', element.id, (element.dtFim + ' ' + `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`))"
                            v-model="element.dtFim">
                    </td>
                    <td style="max-width: 14rem; min-width: 10.4rem ;padding: 0rem;">
                        <div style="position: relative;">
                            <v-progress-linear
                                :color="(element.status == 'Cancelada') ? 'red' : (element.status == 'Concluído') ? 'var(--cor-sucesso)' : (element.status == 'Pendente') ? 'var(--cor-alerta)' : (element.status == 'Em andamento' || 'Em andamento 25%' || 'Em andamento 50%' || 'Em andamento 75%') ? 'var(--cor-ok)' : 'red'"
                                :model-value="element.status == 'Concluído' || element.status == 'Cancelada' ? 100 : element.status == 'Pendente' ? 100 : element.status.split(' ')[2] ? element.status.split(' ')[2].slice(0, 2) : 2"
                                style="border: 1px solid var(--cor-fonte-fraca); border-radius: 25px; height: 2rem;">
                            </v-progress-linear>
                            <select :title="element.status"
                                :style="{ 'color': (element.status == 'Concluído') ? 'var(--cor-bg)' : 'black' }"
                                style="opacity: 1;border: none; padding-left: 0.5rem;position: absolute; top: 0; left: 0rem; outline: none; border-radius: 25px ;height: 2rem ;text-align: center; background-color: transparent; padding-top: 0rem; padding-bottom: 0rem;"
                                @change="editarBacklog('status', element.id, element.status)" v-model="element.status">
                                <option value="" hidden></option>
                                <option style="color: rgb(255, 145, 0);" value="Pendente">A iniciar
                                </option>
                                <option style="color: rgb(0, 47, 255);" :value="'Em andamento'">Em
                                    andamento
                                    0%</option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 25%</option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 50%</option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 75%</option>
                                <option style="color: rgb(0, 192, 0);">Concluído</option>
                                <option style="color: red;">Cancelada</option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <v-menu>
                            <template v-slot:activator="{ props }">
                                <v-btn :id="'botaoEdicao' + element.id"
                                    style="visibility: hidden; width: 2rem; height: 2rem; background-color: transparent; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                                    class="botaoAdicionarSprint acao-secundaria" icon="mdi-dots-horizontal"
                                    v-bind="props"></v-btn>
                            </template>

                            <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                <v-list-item style="margin: 0.2rem;" @click="abrirModalEditarBacklog(element)">
                                    Editar Tarefa
                                </v-list-item>
                                <v-list-item>
                                    <v-menu>
                                        <template v-slot:activator="{ props }">
                                            <span style="color: var(--cor-erro);margin: 0.2rem; cursor: pointer;"
                                                v-bind="props">Excluir Tarefa</span>
                                        </template>
                                        <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                            <v-list-item>
                                                <div>
                                                    <h3>Tem certeza? Esta ação é Irreversível!</h3>
                                                    <div class="submit">
                                                        <Button @click="apagarBacklog(element.id)">Excluir</Button>
                                                        <button class="acao-secundaria">Cancelar</button>
                                                    </div>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </tbody>
        </table>
        <div style="display: flex; padding-left: 0.2rem; border-radius: 5px; width: 100%;">
            <div
                style="border: 1px solid var(--cor-separador); border-radius: 5px; padding: 0.3rem; width: 6rem; align-content: center ;text-align: center;">
                <strong>
                    {{ codNovaTarefa }}
                </strong>
            </div>
            <div
                style="border: 1px solid var(--cor-separador); border-radius: 5px; width: 100%; margin-left: 0.3rem; padding: 0.3rem;">
                <input type="text" placeholder="O que será feito?"
                    @keyup.enter="criarBacklog($event.target.value), $event.target.value = ''"
                    style="width: 100%; padding: 0.1rem; padding-left: 0.5rem; outline: none; height: 2rem; border: none;">
            </div>
        </div>
    </div>

    <ModalEditarBacklog :mostrar="showEditarBacklog" :backlog="backlogeditado" :gerente="gerente"
        :url-foto="urlFoto" @fechar="showEditarBacklog = false" @editar="editarBacklog"
        @excluir-anexo="excluirAnexo" @upload-anexos="handleFileUploadFromModal" />
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import { ref } from "vue";
import { useApiError } from "@/composables/useApiError";
import { consultarSetores } from "@/services/usuario-setor";
import { urlFoto } from "@/services/api";
import serviceFunções from "@/services/serviceFunções";
import serviceProjetos from "@/services/serviceProjetos";
import {
    atualizarPlanoAcaoTarefa,
    adicionarAnexoPlanoAcaoTarefa,
    cadastrarTarefaPlanoAcao,
    excluirTarefaPlanoAcao,
} from "@/services/serviceGestaoTarefas";
import ModalEditarBacklog from "@/components/Modais/PAP/ModalEditarBacklog.vue";

export default {
    name: "VisualizaçãoPlanodeAção",
    components: { ModalEditarBacklog },
    setup() {
        const fileInput = ref(null);
        const { handleError } = useApiError();

        const openFileInput = () => {
            fileInput.value.click();
        };
        const somarHP = (dados) => {
            return serviceFunções.somarHP(dados);
        };
        const nomeEsobrenome = (nome) => {
            return serviceFunções.nomeEsobrenome(nome);
        };
        return { fileInput, openFileInput, urlFoto, somarHP, nomeEsobrenome, handleApiError: handleError };
    },

    props: {
        propPAP: {
            required: true
        },
    },

    watch: {
        propPAP: {
            immediate: true,
            handler(novoValor) {
                this.sprint = novoValor
            }
        }
    },

    computed: {
        codNovaTarefa() {
            const tarefas = this.sprint?.tarefas;
            if (Array.isArray(tarefas)) {
                return `Tarefa - ${tarefas.length + 1}`;
            }
            return "Tarefa - 1";
        }
    },

    data() {
        return {
            sprint: {},
            pcm_codigo: null,
            pcm_id: null,
            idProjeto: null,
            nome: null,
            perfil: null,
            pdfUrl: null,
            idUsuario: null,
            backlogs: [],
            showEditarSprint: false,
            showEditarBacklog: false,
            showIniciarSprint: false,
            showConfirmação: false,
            idSprint: null,
            backlogeditado: null,
            gerente: [],
            sprintEditada: null
        }
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id;
        this.getGerenteseSetor();

    },

    methods: {
        async handleFileUploadFromModal(files) {
            if (!files?.length || !this.backlogeditado?.id) return;
            const formData = new FormData();
            formData.append("planoAcaoTarefa_id", this.backlogeditado.id);
            for (let i = 0; i < files.length; i++) {
                formData.append("anexos[]", files[i]);
            }
            try {
                const data = await adicionarAnexoPlanoAcaoTarefa(formData);
                if (data?.anexos_salvos?.length) {
                    data.anexos_salvos.forEach((a) => {
                        this.backlogeditado.anexos.push({ path: a.path, nome: a.nome, id: a.id });
                    });
                }
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async excluirAnexo(id) {
            try {
                await serviceProjetos.excluirAnexoTarefa(id);
                this.backlogeditado.anexos = this.backlogeditado.anexos.filter((anexo) => anexo.id !== id);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        mostrarBotaoExcluirAnexo(id, mostrar) {
            if (mostrar == true) {
                document.getElementById('botaoExcluir' + id).style.visibility = ''
            }
            if (mostrar == false) {
                document.getElementById('botaoExcluir' + id).style.visibility = 'hidden'
            }
        },

        async getGerenteseSetor() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.gerente = usuarios;
                this.setores = setores;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        mostrarBotao(id, mostrar) {
            if (mostrar == true) {
                document.getElementById('botaoEdicao' + id).style.visibility = ''
            }
            if (mostrar == false) {
                document.getElementById('botaoEdicao' + id).style.visibility = 'hidden'
            }
        },

        getBacklogs() {
            this.$emit('atualizar');
        },

        async definirInicioFimReal(idBacklog, status) {
            const d = new Date();
            const data = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, "0"), String(d.getDate()).padStart(2, "0")].join("-");
            try {
                if (status === "Em andamento") {
                    await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtInicioReal: data });
                } else if (status === "Concluído") {
                    await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtFimReal: data });
                } else if (status === "Pendente") {
                    await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtInicioReal: null, dtFimReal: null });
                } else {
                    await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, dtFimReal: null });
                }
                this.getBacklogs();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        abrirModalEditarBacklog(tarefa) {
            this.backlogeditado = tarefa
            this.showEditarBacklog = true;
        },

        async editarBacklog(itemAlterado, idBacklog, novoValor) {
            try {
                await atualizarPlanoAcaoTarefa(idBacklog, { usuario_id: this.idUsuario, [itemAlterado]: novoValor });
                if (itemAlterado === "status") {
                    await this.definirInicioFimReal(idBacklog, novoValor);
                }
            } catch (error) {
                this.handleApiError(error);
            }
        },

        fecharModalFora(event) {
            if (event.target.classList.contains('modal-mask')) {
                this.showEditarBacklog = false;
                this.showIniciarSprint = false;
                this.showConfirmação = false;
                this.showEditarSprint = false
            }

        },

        fecharModal() {
            this.showIniciarSprint = false;
        },

        async criarBacklog(descricao) {
            try {
                const res = await cadastrarTarefaPlanoAcao({
                    planoAcao_id: this.sprint.id,
                    codigo: this.codNovaTarefa,
                    descricao,
                });
                const novoItem = {
                    id: res.id,
                    sprint_id: this.sprint.id,
                    codigo: this.codNovaTarefa,
                    descricao,
                    HP: 0,
                    responsavel_id: 0,
                    status: "Pendente",
                    dtInicio: null,
                    dtFim: null,
                    dtInicioReal: null,
                    dtFimReal: null,
                    responsavel: null,
                    anexos: [],
                };
                if (!Array.isArray(this.sprint.tarefas)) this.sprint.tarefas = [];
                this.sprint.tarefas.push(novoItem);
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async apagarBacklog(idBacklog) {
            try {
                await excluirTarefaPlanoAcao(idBacklog, this.idUsuario);
                if (Array.isArray(this.sprint.tarefas)) {
                    this.sprint.tarefas = this.sprint.tarefas.filter((t) => t.id !== idBacklog);
                }
                this.showEditarBacklog = false;
            } catch (error) {
                this.handleApiError(error);
            }
        },
    }
}
</script>

<style scoped></style>